"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _appLoaders = require("@ori-appshell/app-loaders");
var _rendering = require("@ori-appshell/rendering");
var _shared = require("@ori-appshell/shared");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _favoritesHeart = require("@ori/favorites-heart");
var _featureToggles = require("@ori/feature-toggles");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _react = require("react");
var _internals = require("../../internals");
var _translations = require("../../layouts/default/translations");
var _logger2 = require("../../logger");
var _Analytics = require("../Analytics");
var _CultureProvider = require("../CultureProvider/CultureProvider");
var _Head = require("../Head");
var _LoginProvider = require("../LoginProvider");
var _jsxRuntime = require("react/jsx-runtime");
const Page = ({
  children,
  cultureSettings,
  customerId,
  developmentInfo,
  defaultTranslations,
  environment,
  features,
  isProduction,
  language,
  pageBuiltAt,
  pageFeatures,
  pageMetaData,
  periodCode,
  servicesUrls,
  tenant,
  token,
  translations,
  useLegacyKendoCulture = false,
  useLegacyTokenService = false,
  enableWebVitalsCollection = false,
  enableFavorites = false,
  operationId,
  appLoaders
}) => {
  const devInfoFeatures = (0, _react.useMemo)(() => (0, _internals.mapFeatureToggles)(features, pageFeatures), [features, pageFeatures]);
  const extraInfo = (0, _react.useMemo)(() => ({
    pageBuiltAt
  }), [pageBuiltAt]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Head.Head, {
      pageMetaData: pageMetaData,
      environment: environment
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_environment.EnvironmentProvider, {
      environment: environment,
      tenant: tenant,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_configurationManager.ServiceUrlsProvider, {
          serviceUrls: servicesUrls,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
            language: language,
            defaultTranslationsWithNamespaces: defaultTranslations ?? _translations.defaultLayoutTranslationKeysWithNamespaces,
            translationsWithNamespaces: translations,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_auth.UniversalTokenProvider, {
              initialToken: token,
              customerId: customerId,
              children: [!!useLegacyTokenService && /*#__PURE__*/(0, _jsxRuntime.jsx)(_auth.LegacyTokenService, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.DevelopmentInfoScript, {
                info: developmentInfo,
                tenant: tenant,
                isProduction: isProduction,
                extraInfo: extraInfo,
                featureToggles: devInfoFeatures,
                operationId: operationId ?? undefined
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_featureToggles.FeatureTogglesProvider, {
                toggles: features,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CultureProvider.CultureProvider, {
                  cultureSettings: cultureSettings,
                  useLegacyKendoCulture: useLegacyKendoCulture,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_appLoaders.AppLoadersProvider, {
                    defaultValues: appLoaders,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_LoginProvider.LoginProvider, {
                      children: [enableWebVitalsCollection ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_rendering.WebVitals, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Analytics.AnalyticsDataInitialization, {
                        data: {
                          periodCode
                        }
                      }), enableFavorites ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_favoritesHeart.FavoritesProvider, {
                        children: children
                      }) : children]
                    })
                  })
                })
              })]
            })
          })
        })
      })
    })]
  });
};
exports.Page = Page;
